// extracted by mini-css-extract-plugin
export default {"bodyLayout":"course-mapping-course_bodyLayout__8w1uH","headerImage":"course-mapping-course_headerImage__Rc9Fa","buttons":"course-mapping-course_buttons__j2+C+"};